import { useCallback, useEffect, useRef, useState } from "react";
import { Clock3, UserPlus } from "lucide-react";
import { Button } from "./ui/button";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "./ui/dialog";

const INACTIVITY_MS = 30 * 60 * 1000;

export const DemoInactivityPrompt = ({ linkMode = false, onLeave }) => {
  const [open, setOpen] = useState(false);
  const timer = useRef(null);

  const reset = useCallback(() => {
    if (timer.current) window.clearTimeout(timer.current);
    if (!open) timer.current = window.setTimeout(() => setOpen(true), INACTIVITY_MS);
  }, [open]);

  useEffect(() => {
    const events = ["pointerdown", "keydown", "scroll", "touchstart"];
    events.forEach((eventName) => window.addEventListener(eventName, reset, { passive: true }));
    reset();
    return () => {
      events.forEach((eventName) => window.removeEventListener(eventName, reset));
      if (timer.current) window.clearTimeout(timer.current);
    };
  }, [reset]);

  const keepExploring = () => {
    setOpen(false);
    window.setTimeout(reset, 0);
  };

  return (
    <Dialog open={open} onOpenChange={() => {}}>
      <DialogContent className="max-w-md bg-white" data-testid="demo-inactivity-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2"><Clock3 className="h-5 w-5 text-primary" /> Still exploring SimplyRefer?</DialogTitle>
          <DialogDescription>
            Your demo has been inactive for 30 minutes. Continue to keep this session open, or leave the demo. Demo references expire when the session ends.
          </DialogDescription>
        </DialogHeader>
        <div className="mt-3 flex flex-wrap justify-end gap-2">
          <Button variant="outline" onClick={keepExploring} data-testid="demo-continue-session">Continue demo</Button>
          <Button onClick={onLeave} data-testid="demo-inactivity-leave">
            {linkMode && <UserPlus className="mr-2 h-4 w-4" />}
            {linkMode ? "Create Free GP Account" : "Exit demo"}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
